import * as Roles from  "./roles"
import {Progress} from "reactstrap";
import React from "react";

export function fileProgressClass(file){

}

export function fileApprovedCount(files,role){
    let count=0;
    if(null !== files)
        files.map(file=>{
            if(role === Roles.BANK_AUTHORIZER && file.status === Roles.FILE_STATUS_BANK_CORPORATE_VERIFIED){
                count=count+1;
            }else if(role === Roles.CORPORATE_AUTHORIZER && file.status === Roles.FILE_STATUS_DRAFT){
                count=count+1;
            }
            return ""
        })
    return count;

}

export function fileThisMonthCount(files) {

    if(files !== null)
        return files.length
    else
        return 0;

}

export function getFileProgress(files) {
    let fileRow= <tr></tr>
    if(null !== files)
      files.map(function(file){
            return <tr>
                <th scope="row">{file.fileName}</th>
                <td>{file.status}</td>
            <td>
                <div className="d-flex align-items-center">
                    <span className="mr-2">{getValue(file.status)}%</span>
                    <div>
                        <Progress
                            max="100"
                            value={getValue(file.status)}
                            barClassName={getClass(file.status)}
                        />
                    </div>
                </div>
            </td>
            </tr>
        }
    )
    return fileRow;
}

export function getValue(status) {
    if(status === Roles.FILE_STATUS_DRAFT){
        return 20;
    }else if(status === Roles.FILE_STATUS_BANK_CORPORATE_VERIFIED){
        return 40;
    }else if(status === Roles.FILE_STATUS_BANK_AUTHORIZER_VERIFIED_1 || status === Roles.FILE_STATUS_BANK_AUTHORIZER_VERIFIED_2){
        return 60;
    }else if(status === Roles.FILE_STATUS_FINAL_APPROVED){
        return 60;
    }else if(status === Roles.FILE_STATUS_SEND_KO){
        return 0;
    }
    else if(status === Roles.FILE_STATUS_SEND_OK){
        return 90;
    }
    else if(status === Roles.FILE_STATUS_ACQUIRED){
        return 100;
    }
    else if(status === Roles.FILE_STATUS_NOT_ACQUIRED){
        return 0;
    }
}

export function getClass(status) {

    if(status === Roles.FILE_STATUS_DRAFT){
        return "bg-info";
    }else if(status === Roles.FILE_STATUS_BANK_CORPORATE_VERIFIED){
        return "bg-primary";
    }else if(status === Roles.FILE_STATUS_BANK_CORPORATE_AUTHORIZER_VERIFIED){
        return "bg-secondary";
    }else if(status === Roles.FILE_STATUS_FINAL_APPROVED){
        return "bg-green";
    }else if(status === Roles.FILE_STATUS_SEND_KO){
        return "bg-danger";
    }
    else if(status === Roles.FILE_STATUS_ACQUIRED){
        return "bg-gradient-success";
    }
    else if(status === Roles.FILE_STATUS_NOT_ACQUIRED){
        return "bg-danger";
    }
}